import { Navigate, useLocation } from "react-router-dom";

import { useSessionScope } from "@/lib/session-scope";

/**
 * Gates the app behind a chosen gate. Without one the user is sent to /select-gate?next=<path>
 * and comes back after picking (a QR deep link like /?t=… survives the round trip).
 */
export function RequireScope({ children }: { children: React.ReactNode }) {
  const { scope } = useSessionScope();
  const location = useLocation();

  if (!scope) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/select-gate?next=${next}`} replace />;
  }
  return <>{children}</>;
}
